module.exports = __webpack_public_path__ + "img/search-dark-green-outline@3x.efa6be76.svg";